import Icon from "@ant-design/icons";
import { Collapse, Space, Row, Col } from "antd";
import momentTZ from "moment-timezone";
import {
  OrderPackingListModel,
  OrderShippingConst,
} from "states/order/order.models";
import { OrderShippingStatusTag } from "./order-shipping-status-tag";
import { useSelector, shallowEqual } from "react-redux";
import { momentDateTimeFormat } from "shared/plugins/localization";
import { selectCurrentBranch } from "states/branch/branch.slice";
import { formatMoney, formatPhoneNumber } from "shared/plugins/string-helper";
import { BoxOutlined } from "shared/components/icons";

export interface IOrderPackingListInfoProps {
  orderPackingList: OrderPackingListModel;
  onViewOrAdd: () => void;
  onSuccess: (orderId: string) => void;
  onOpenReturnedModal?: () => void;
}

export function OrderPackingListInfo(props: IOrderPackingListInfoProps) {
  const { orderPackingList, onViewOrAdd, onSuccess, onOpenReturnedModal } =
    props;
  const currentBranch = useSelector(selectCurrentBranch, shallowEqual);
  return orderPackingList.type === OrderShippingConst.shippingType.delivery ? (
    <div className="mb-2 bg-white">
      <Collapse ghost expandIconPosition={"right"}>
        <Collapse.Panel
          header={
            <Space>
              <div>
                <BoxOutlined /> <b>Vận đơn</b>{" "}
              </div>
              <OrderShippingStatusTag status={orderPackingList.status} />
            </Space>
          }
          key={`packinglistInfo${orderPackingList.id}`}
        >
          <>
            <Row
              gutter={[8, 8]}
              justify="space-between"
              align="middle"
              className="mb-2"
            >
              <Col>Trạng thái:</Col>
              <Col>
                <OrderShippingStatusTag status={orderPackingList.status} />
              </Col>
            </Row>
            <Row
              gutter={[8, 8]}
              justify="space-between"
              align="middle"
              className="mb-2"
              wrap={false}
            >
              <Col>Địa chỉ:</Col>
              <Col style={{ textAlign: "right" }}>
                {orderPackingList?.shippingAddress?.street},{" "}
                {orderPackingList?.shippingAddress?.wardName}
                <br />
                {orderPackingList?.shippingAddress?.districtName},{" "}
                {orderPackingList?.shippingAddress?.provinceName}
              </Col>
            </Row>
            <Row
              gutter={[8, 8]}
              justify="space-between"
              align="middle"
              className="mb-2"
              wrap={false}
            >
              <Col>Người nhận:</Col>
              <Col style={{ textAlign: "right" }}>
                {orderPackingList?.shippingAddress?.firstName}{" "}
                {orderPackingList?.shippingAddress?.lastName}
                <br />
                {formatPhoneNumber(
                  orderPackingList?.shippingAddress?.phoneNumber ?? ""
                )}
              </Col>
            </Row>
            <Row
              gutter={[8, 8]}
              justify="space-between"
              align="middle"
              className="mb-2"
            >
              <Col>Tiền thu hộ:</Col>
              <Col>{formatMoney(orderPackingList?.collectionAmount)}</Col>
            </Row>
            <Row
              gutter={[8, 8]}
              justify="space-between"
              align="middle"
              className="mb-2"
            >
              <Col>Nhà vận chuyển:</Col>
              <Col>{orderPackingList?.shippingCompanyCode}</Col>
            </Row>
            <Row
              gutter={[8, 8]}
              justify="space-between"
              align="middle"
              className="mb-2"
            >
              <Col>Mã vận đơn:</Col>
              <Col>
                <b>{orderPackingList?.billOfLadingCode}</b>
              </Col>
            </Row>
          </>
        </Collapse.Panel>
      </Collapse>
    </div>
  ) : (
    <div className="mb-2 p-2 bg-white">
      <div className="mb-2">
        <Icon component={BoxOutlined} /> <b>Thông tin Pickup</b>
      </div>
      <Row
        gutter={[8, 8]}
        justify="space-between"
        align="middle"
        className="mb-2"
        wrap={false}
      >
        <Col flex="115px">Giờ lấy hàng:</Col>
        <Col style={{ textAlign: "right" }}>
          {momentTZ
            .tz(
              orderPackingList.requestedPickupTime,
              currentBranch?.ianaTimeZone
            )
            .format(momentDateTimeFormat())}
        </Col>
      </Row>
    </div>
  );
}
